import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  create: function ($, task) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/tasks`, task)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  update: function ($, id, task) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/projects/tasks/${id}`, task)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  remove: function ($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/projects/tasks/${id}`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  list(projectId, onlyIncoming = false) {
    let url = `projects/${projectId}/tasks`
    if (onlyIncoming) {
      url += "?only_incoming=true"
    }
    return new Promise((resolve, reject) => {
      HTTP.get(url)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
